import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

const Meniu = () => {
  const [meniu, setMeniu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    nume: '',
    descriere: '',
    categorie: 'pranz',
    pret: '',
    disponibil: true,
    alergeni: ''
  });

  const categorii = [
    { value: 'mic dejun', label: 'Mic Dejun' },
    { value: 'gustare dimineata', label: 'Gustare Dimineață' },
    { value: 'pranz', label: 'Prânz' },
    { value: 'gustare dupa-amiaza', label: 'Gustare După-Amiază' }
  ];

  useEffect(() => {
    loadMeniu();
  }, []);

  const loadMeniu = async () => {
    try {
      const response = await axios.get('/api/meniu');
      setMeniu(response.data);
    } catch (error) {
      console.error('Eroare la încărcare meniu:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        ...formData,
        pret: parseFloat(formData.pret),
        alergeni: formData.alergeni ? formData.alergeni.split(',').map(a => a.trim()) : []
      };

      if (editingItem) {
        await axios.put(`/api/meniu/${editingItem._id}`, data);
      } else {
        await axios.post('/api/meniu', data);
      }
      loadMeniu();
      closeModal();
    } catch (error) {
      console.error('Eroare la salvare articol:', error);
      alert('Eroare la salvare articol');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      nume: item.nume,
      descriere: item.descriere || '',
      categorie: item.categorie,
      pret: item.pret,
      disponibil: item.disponibil,
      alergeni: item.alergeni ? item.alergeni.join(', ') : ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sigur dorești să ștergi acest articol?')) {
      try {
        await axios.delete(`/api/meniu/${id}`);
        loadMeniu();
      } catch (error) {
        console.error('Eroare la ștergere articol:', error);
        alert('Eroare la ștergere articol');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setFormData({
      nume: '',
      descriere: '',
      categorie: 'pranz',
      pret: '',
      disponibil: true,
      alergeni: ''
    });
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Gestiune Meniu</h1>
          <p>Gestionează articolele din meniu</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Adaugă Articol
        </button>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Nume</th>
              <th>Categorie</th>
              <th>Preț (lei)</th>
              <th>Disponibil</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {meniu.map((item) => (
              <tr key={item._id}>
                <td>
                  <strong>{item.nume}</strong>
                  {item.descriere && <div style={{fontSize: '0.85rem', color: '#666'}}>{item.descriere}</div>}
                </td>
                <td>{item.categorie}</td>
                <td>{item.pret.toFixed(2)} lei</td>
                <td>
                  <span className={`badge ${item.disponibil ? 'badge-success' : 'badge-danger'}`}>
                    {item.disponibil ? 'Da' : 'Nu'}
                  </span>
                </td>
                <td>
                  <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(item)}>
                    Editează
                  </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item._id)}>
                    Șterge
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingItem ? 'Editează Articol' : 'Adaugă Articol Nou'}</h2>
              <button className="modal-close" onClick={closeModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nume Articol *</label>
                <input
                  type="text"
                  value={formData.nume}
                  onChange={(e) => setFormData({ ...formData, nume: e.target.value })}
                  required
                  placeholder="ex: Supă de legume"
                />
              </div>
              <div className="form-group">
                <label>Descriere</label>
                <textarea
                  value={formData.descriere}
                  onChange={(e) => setFormData({ ...formData, descriere: e.target.value })}
                  placeholder="Descriere articol..."
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Categorie *</label>
                <select
                  value={formData.categorie}
                  onChange={(e) => setFormData({ ...formData, categorie: e.target.value })}
                  required
                >
                  {categorii.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Preț (lei) *</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.pret}
                  onChange={(e) => setFormData({ ...formData, pret: e.target.value })}
                  required
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Alergeni (despărțiți prin virgulă)</label>
                <input
                  type="text"
                  value={formData.alergeni}
                  onChange={(e) => setFormData({ ...formData, alergeni: e.target.value })}
                  placeholder="ex: gluten, lactate, ouă"
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.disponibil}
                    onChange={(e) => setFormData({ ...formData, disponibil: e.target.checked })}
                  />
                  {' '}Disponibil
                </label>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Anulează
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingItem ? 'Salvează' : 'Adaugă'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Meniu;
